import styled from 'styled-components';
import { COLORS } from '@/theme';
import { DatePicker } from '@/components';

export const StyledFilterRow = styled.tr`
  &&& {
    th {
      background-color: ${COLORS.LIGHTEST_GRAY};
      padding: 1rem 0.5rem;
      font-weight: normal;
    }
    th:last-child {
      border-right: none;
    }
  }
`;

export const StyledDatePicker = styled(DatePicker)`
  height: 2rem;
`;
